import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import RegisterBody from './body.tsx';
import RegisterHeader from './header.tsx';

const Register = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (isLoggedIn)
            navigate("/journal");
    }, [isLoggedIn, navigate]);

    if (isLoggedIn)
        return null;

    return (
        <>
            <RegisterHeader />
            <RegisterBody />
        </>
    );
};

export default Register;
